import {createI18n} from "vue-i18n";

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: any = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key).default;
        }
    });
    return messages;
}

const lang = navigator.language.toLowerCase();
let navigatorLanguage = 'fr_FR'; // default for anything unrecognized
if (lang.startsWith('de')) navigatorLanguage = 'de_DE';
else if (lang.startsWith('en')) navigatorLanguage = 'en_US';
else if (lang.startsWith('fr')) navigatorLanguage = 'fr_FR';

export default createI18n<false>({
    legacy: false,
    locale: navigatorLanguage || process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "fr_FR",
    messages: loadLocaleMessages(),
    globalInjection: true
});
